// extracted by mini-css-extract-plugin
export default {"list":"socials_list__DP34F","listItem":"socials_listItem__BWvir","footer":"socials_footer__d8kr8","people":"socials_people__AG+Mr"};